import { eventBookingStatus } from "./eventBooking.constants";

export const CART_TABLE_HEADER_KEYS = {
  TIP: "tip",
  RATE: "rate",
  TOTAL: "total",
  QUANTITY: "qty",
  STATUS: "status",
  DELETE: "delete",
  DETAILS: "details",
  EVENT_NAME: "eventName",
};

export const DEFAULT_VALUE_CART_TABLE = "-";

export const CART_SUMMARY_STATUS = {
  [eventBookingStatus.CREATED]: {
    label: "Newly Added",
    className: "status-created fw-600",
  },
  [eventBookingStatus.EDITED]: {
    label: "Edited",
    className: "status-edited fw-600",
  },
  [eventBookingStatus.CANCEL]: {
    label: "Cancelled",
    className: "status-deleted fw-600",
  },
  [eventBookingStatus.NOTIFY_ADMIN]: {
    label: "Notify Admin",
    className: "status-notify_admin fw-600",
  },
};

export const discountStatus = {
  PROMO_CODE: "discount",
  GIFT_CARD: "gift_card",
};
